export const FIELD_TYPES = {
  TEXT: "text",
  NUMBER: "number",
  DATE: "date",
  SELECTION: "selection",
};

export const OPERATORS_BY_TYPE = {
  [FIELD_TYPES.TEXT]: [
    { key: "eq", labelKey: "EQ" },
    { key: "neq", labelKey: "NEQ" },
    { key: "contains", labelKey: "CONTAINS" },
    { key: "not_contains", labelKey: "NOT_CONTAINS" },
    { key: "starts", labelKey: "STARTS" },
    { key: "ends", labelKey: "ENDS" },
    { key: "defined", labelKey: "DEFINED" },
    { key: "not_defined", labelKey: "NOT_DEFINED" },
  ],
  [FIELD_TYPES.DATE]: [
    { key: "is", labelKey: "IS_DATE" },
    { key: "before", labelKey: "BEFORE" },
    { key: "after", labelKey: "AFTER" },
    { key: "between", labelKey: "BETWEEN" },
    { key: "defined", labelKey: "DEFINED" },
    { key: "not_defined", labelKey: "NOT_DEFINED" },
  ],
  [FIELD_TYPES.NUMBER]: [
    { key: "eq", labelKey: "EQ" },
    { key: "neq", labelKey: "NEQ" },
    { key: "gt", labelKey: "GT" },
    { key: "lt", labelKey: "LT" },
    { key: "gte", labelKey: "GTE" },
    { key: "lte", labelKey: "LTE" },
    { key: "between", labelKey: "BETWEEN" },
    { key: "defined", labelKey: "DEFINED" },
    { key: "not_defined", labelKey: "NOT_DEFINED" },
  ],
  [FIELD_TYPES.SELECTION]: [
    { key: "is", labelKey: "IS_SELECTION" },
    { key: "is_not", labelKey: "IS_NOT" },
    { key: "defined", labelKey: "DEFINED" },
    { key: "not_defined", labelKey: "NOT_DEFINED" },
  ],
};

export const NO_VALUE_OPERATORS = ["defined", "not_defined"];

export const RANGE_OPERATORS = ["between"];

export const DATE_PRESETS_KEYS = [
  "TODAY",
  "YESTERDAY",
  "LAST_7_DAYS",
  "LAST_30_DAYS",
  "THIS_MONTH",
  "LAST_MONTH",
];

export const getAvailableFields = (fields, context = {}) =>
  Object.values(fields).filter((f) => !f.visibleWhen || f.visibleWhen(context));

export const getFieldConfig = (fieldKey, fields) =>
  Object.values(fields).find((f) => f.key === fieldKey);
